import { NAV, sectionForPath } from "../lib/sections";

<let/isOpen=false>
<const/alertData=$global.alerts>
<const/path=$global.url?.pathname || "/">
<const/current=sectionForPath(path)>
<const/count=$global.visitorCount>
<const/tabClass=(s) => [
  "tab label",
  s.key === "hire" ? "bar--action" : (current?.key === s.key && `bar--${s.role}`),
]>

<header class="site-header sticky top-0 z-40 bg-c-000/95 backdrop-blur border-b border-rule">
  <if=(alertData && alertData[0] === "TRUE")>
    <alert alertText=alertData[1] showAlert=true/>
  </if>

  <!-- Utility strip (spec §4.2) -->
  <div data-strip class="hidden sm:block bg-screen border-b border-rule">
    <div class="wrap flex justify-between gap-4 py-1 label text-c-400">
      <span><span class="text-c-900">MC 1430.2</span> &middot; Field manual &middot; Rev. ${new Date().getFullYear()}</span>
      <span>Brooklyn, NY &middot; Visitors ${count ? String(count).padStart(6, "0") : "------"}</span>
    </div>
  </div>

  <nav class="wrap flex items-center justify-between gap-3 sm:gap-6 h-14" aria-label="Main">
    <a href="/" class="flex items-center gap-2 sm:gap-3 whitespace-nowrap text-c-900">
      <span class="logo-mark" aria-hidden="true"></span>
      <span class="text-lg sm:text-xl font-medium tracking-[-0.03em] lowercase">mark condor</span>
    </a>

    <!-- Full boxed tab bar from xl -->
    <ul class="hidden xl:flex gap-1">
      <for|s| of=NAV>
        <li>
          <a data-tab href=s.href aria-current=(current?.key === s.key ? "page" : undefined) class=tabClass(s)>${s.label}</a>
        </li>
      </for>
    </ul>

    <!-- Below xl: Hire stays visible; Menu opens the rest -->
    <div class="flex items-center gap-1 xl:hidden">
      <a href="/hire" class="tab label bar--action">Hire</a>
      <button
        type="button"
        class="tab label"
        aria-expanded=(isOpen ? "true" : "false")
        aria-controls="menu-tabs"
        onClick() { isOpen = !isOpen }
      >Menu ${isOpen ? "▴" : "▾"}</button>
    </div>
  </nav>

  <ul id="menu-tabs" class=["xl:hidden wrap pb-3 grid gap-1", !isOpen && "hidden"]>
    <for|s| of=NAV>
      <li>
        <a href=s.href aria-current=(current?.key === s.key ? "page" : undefined) class=[...tabClass(s), "w-full"] onClick() { isOpen = false }>${s.label}</a>
      </li>
    </for>
  </ul>
</header>

<style>
  .logo-mark {
    width: 18px;
    height: 18px;
    background: #e03c31;
    border-radius: 5px !important;
    position: relative;
  }
  .logo-mark::after {
    content: "";
    position: absolute;
    inset: 5px;
    border-radius: 50% !important;
    background: var(--c-000);
  }
  .tab {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    padding: 0 0.5rem;
    border: 1px solid var(--rule);
    color: var(--c-700);
    white-space: nowrap;
    transition: transform 0.14s var(--ease-snap), border-color 0.15s ease;
  }
  @media (min-width: 640px) { .tab { padding: 0 0.7rem; } }
  .tab:hover { opacity: 1; border-color: var(--c-500); }
  .tab:active { transform: translateY(1px); }
  .tab[class*="bar--"] { border-color: transparent; }
  @media (prefers-reduced-motion: reduce) { .tab, .tab:active { transition: none; transform: none; } }
</style>
